import { useContext, useMemo } from 'react'
import Crop from '../../../cropper'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeCropContext } from '../../contexts/crop'
import { cropAspectRatio } from '../../types/crop'
import { Overlay } from '../style'

type Props = {
    hidden?: boolean
}

const CropOverlay = ({ hidden = false }: Props) => {
    const { height, width } = useContext(UgeArtboardContext)
    const { crop, cropType, setCrop } = useContext(UgeCropContext)
    const aspectRatio = useMemo(() => cropAspectRatio(cropType, width / height), [cropType, height, width])

    return (
        <Overlay style={hidden ? { opacity: 0 } : undefined}>
            <Crop
                aspectRatio={aspectRatio}
                crop={crop}
                height={height}
                width={width}
                onChange={setCrop}
                showDimensions
            />
        </Overlay>
    )
}

export default CropOverlay
